var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseRegularFull1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50002 2.1906C9.78439 1.93435 10.2156 1.93435 10.5 2.1906L17.75 8.6906C18.0594 8.9656 18.0844 9.4406 17.8063 9.74998C17.5281 10.0594 17.0563 10.0844 16.7469 9.80623L16.4969 9.58123L16.4969 15.9969C16.4969 17.1 15.6 17.9969 14.4969 17.9969L5.49689 17.9969C4.39377 17.9969 3.49689 17.1 3.49689 15.9969L3.49689 9.58123L3.24689 9.80623C2.93752 10.0812 2.46564 10.0562 2.18752 9.74998C1.90939 9.44373 1.93752 8.96873 2.24377 8.69061L9.50002 2.1906ZM10 3.75623L5.00002 8.24061L5.00002 16C5.00002 16.275 5.22502 16.5 5.50002 16.5L7.00002 16.5L7.00002 13.25C7.00002 12.0062 8.00627 11 9.25002 11L10.75 11C11.9938 11 13 12.0062 13 13.25L13 16.5L14.5 16.5C14.775 16.5 15 16.275 15 16L15 8.2406L10 3.75935L10 3.75623ZM8.50002 16.5L11.5 16.5L11.5 13.25C11.5 12.8344 11.1656 12.5 10.75 12.5L9.25002 12.5C8.83439 12.5 8.50002 12.8344 8.50002 13.25L8.50002 16.5Z",
    fill: "#1D1F2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseRegularFull1);
export default __webpack_public_path__ + "static/media/house-regular-full 1.3862bd6196752d571d440cfb99d37944.svg";
export { ForwardRef as ReactComponent };